import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=fc0b90ba&scoped=true&"
import script from "./Payments.vue?vue&type=script&lang=js&"
export * from "./Payments.vue?vue&type=script&lang=js&"
import style0 from "./Payments.vue?vue&type=style&index=0&id=fc0b90ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0b90ba",
  null
  
)

export default component.exports